import React, { useContext } from 'react';

import clsx from 'clsx';

import { Grid, makeStyles, View, Stack } from '@gogame/components';

import {
  useCreate,
  useIsUpdating,
  useRemove,
  useUpdate,
} from 'scenes/Gallery/GalleryPage/Creatives/Comments/data';
import {
  CreateCommentForm,
  CommentsList,
} from 'scenes/Gallery/components/Comments';
import { loadUsersSuggestions } from 'scenes/Gallery/GalleryPage/sources/mentions';

import CommentsContext from './CommentsContext';

const useStyles = makeStyles(() => ({
  container: {
    minHeight: '430px',
  },
}));

const Comments = ({ className, minHeight, itemSize }) => {
  const classes = useStyles();
  const { isLoading, data, creativeId } = useContext(CommentsContext);
  const isUpdating = useIsUpdating();
  const [addComment] = useCreate();
  const [updateComment] = useUpdate();
  const [removeComment] = useRemove();

  const handleAddComment = ({ text }) =>
    addComment({ parentId: creativeId, creativeId, text });

  const handleEditComment = ({ id, text }) =>
    updateComment({ parentId: creativeId, creativeId, id, text });

  const handleDeleteComment = (values) =>
    removeComment({ ...values, creativeId });

  return (
    <View loading={isLoading || isUpdating}>
      <Stack className={clsx(className, classes.container)} p={2}>
        <Grid container direction={'column'}>
          <Grid item>
            <CreateCommentForm
              onSubmit={handleAddComment}
              onLoadSuggestions={loadUsersSuggestions}
            />
          </Grid>
          <Grid item>
            <CommentsList
              data={data}
              onEdit={handleEditComment}
              onDelete={handleDeleteComment}
              minHeight={minHeight}
              onLoadSuggestions={loadUsersSuggestions}
              itemSize={itemSize || 4}
            />
          </Grid>
        </Grid>
      </Stack>
    </View>
  );
};
export default Comments;
